import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';

// import { setUpBrowserListeners } from './state/slices/browserUtils';

import Footer from './views/footer';
import Content from './views/content';

import { fetchData } from './state/slices/data';
import store from './state/store';
import { setUpBrowserListeners } from './state/slices/browserUtils';

const container = document.getElementById('foot');
const root = createRoot(container);

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div className="content-wrap">
      <Content />
      <Footer />
    </div>
  </Provider>
);

root.render(element);

/* Start up functions */
/* Initial data fetch */
setUpBrowserListeners(store.dispatch);
store.dispatch(fetchData());
